import { Component } from '@angular/core';

@Component({
    selector: 'app-client-logo-slider',
    templateUrl: './client-logo-slider.component.html',
    styleUrls: ['./client-logo-slider.component.scss']
})
export class ClientLogoSliderComponent {
    // Placeholder logos until user provides new ones
    logos = [
        { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/IS6TvdFMURcYHKLNjcKhaVKW1KZnaxi07mPTHN8h.png', alt: 'LIC' },
        { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/1jU6WDy5qT2AIngAkj7QNSMjdrb0HEM8ts9Ln5sK.jpg', alt: 'meit' },
        { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/juReicZD7xx0XFSW6QINtnjW7OjMyEdDljhIUx4G.jpg', alt: 'cmpdi' },
        // { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/zp2247IomebMxfiW2Qm9LvvJMmqvNcJKjjDWtryW.png', alt: 'India Post' },
        { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/GqMqSDV16XMxhybnRnqC1BzCR86Kv4ABfldPdL0j.png', alt: 'IITM' },
        { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/K2Qfm9Yl7qArpCDcIYptBOKoCBj48VqiABue2pEi.png', alt: 'Maulana Azad NIT' },
        { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/hxS9tciWSZEJPPO1xjnE00kY3DdLqADU79t06esf.png', alt: 'KVS' },
        // { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/tDvpX7PU2wx0CwP9eITCvrxF416iRTLrD68dU2SJ.jpg', alt: 'bsf' },
        { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/E4vVDDGyUNysiEHOsABuXDiCQddYCsucX9Bba6C2.jpg', alt: 'CPRI' },
        { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/zbulPu5QgI8LppRAtZNlx0YlHglTTPDEMfcRa9yW.jpg', alt: 'JNV' },
        { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/wb4AcMQ8SRufBRpyq8u78xntl82f5QGrG8Hj4a4Z.png', alt: 'DSP' },
        { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/gDkOV1BUK1NmSlqMxlTBj1Gzeb2aHYTTmpwg93Gx.png', alt: 'ISRO' },
        // { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/NQ2IJskhbfir4PM67ri3T7DYKjrGNWO1f3cNJbki.png', alt: 'Indian Army' },
        // { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/RUQoCVLEihIO1EjJC9HYWrmgesfuA0KLCFmYNw7o.jpg', alt: 'barc' },

    ];
}
